import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import authService from '@/services/auth.js';

const TOKEN_KEY = 'vip_admin_token';
const USER_KEY = 'vip_admin_user';

export const useAuthStore = defineStore('auth', () => {
  const token = ref(localStorage.getItem(TOKEN_KEY) || null);
  const user = ref(safeParse(localStorage.getItem(USER_KEY)));

  const isAuthenticated = computed(() => !!token.value && !!user.value);
  const isAdmin = computed(() => user.value?.role === 'admin');

  function persist() {
    if (token.value) localStorage.setItem(TOKEN_KEY, token.value);
    else localStorage.removeItem(TOKEN_KEY);
    if (user.value) localStorage.setItem(USER_KEY, JSON.stringify(user.value));
    else localStorage.removeItem(USER_KEY);
  }

  async function login(email, password) {
    const { token: t, user: u } = await authService.login(email, password);
    token.value = t;
    user.value = u;
    persist();
    return u;
  }

  async function logout() {
    await authService.logout().catch(() => {});
    softLogout();
  }

  // Used by api.js interceptor on 401 — clears state without making a network call.
  function softLogout() {
    token.value = null;
    user.value = null;
    persist();
  }

  async function refreshMe() {
    try {
      const u = await authService.me();
      user.value = u;
      persist();
      return u;
    } catch {
      softLogout();
      return null;
    }
  }

  return { token, user, isAuthenticated, isAdmin, login, logout, softLogout, refreshMe };
});

function safeParse(str) {
  if (!str) return null;
  try { return JSON.parse(str); } catch { return null; }
}
